import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import { faqItems } from "@/mocks/homeData";

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredFaqs = faqItems.filter(
    (item) =>
      !searchQuery ||
      item.question.includes(searchQuery) ||
      item.answer.includes(searchQuery)
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      {/* Page Header */}
      <section className="bg-background-100 border-b border-background-300">
        <div className="max-w-[860px] mx-auto px-3 md:px-4 py-8 md:py-10">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-400 transition-colors mb-3"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            홈으로
          </Link>
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 flex items-center justify-center text-primary-500">
              <i className="ri-question-answer-line text-2xl" />
            </span>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-foreground-700">자주 묻는 질문</h1>
              <p className="text-sm text-foreground-600 mt-0.5">
                월드컵티비 시즌2에 대해 궁금하신 점을 빠르게 확인하세요
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Search */}
      <section className="max-w-[860px] mx-auto px-3 md:px-4 py-6">
        <div className="relative max-w-[400px] mx-auto mb-8">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-foreground-600">
            <i className="ri-search-line text-sm" />
          </span>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="질문을 검색해보세요"
            className="w-full bg-background-100 border border-background-300 rounded-lg pl-9 pr-4 py-2.5 text-sm text-foreground-700 placeholder-foreground-500 outline-none focus:border-primary-500/50 transition-colors"
          />
        </div>

        {/* FAQ List */}
        <div className="flex flex-col gap-2">
          {filteredFaqs.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-background-200 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-foreground-600">
                  <i className="ri-search-line" />
                </span>
              </div>
              <p className="text-sm text-foreground-600">검색 결과가 없습니다</p>
            </div>
          ) : (
            filteredFaqs.map((item, index) => (
              <div
                key={index}
                className="bg-background-100 border border-background-300 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-4 py-4 md:px-5 md:py-4 text-left cursor-pointer"
                >
                  <div className="flex items-start gap-3">
                    <span className="text-sm font-bold text-primary-500 mt-0.5 flex-shrink-0">
                      Q.
                    </span>
                    <span className="text-sm font-medium text-foreground-700">{item.question}</span>
                  </div>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2">
                    <i
                      className={`ri-arrow-down-s-line text-foreground-600 transition-transform ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                    />
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-4 pb-4 md:px-5 md:pb-5">
                    <div className="flex items-start gap-3 pt-3 border-t border-background-300/50">
                      <span className="text-sm font-bold text-accent-500 mt-0.5 flex-shrink-0">
                        A.
                      </span>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        {/* Contact CTA */}
        <div className="mt-10 bg-background-100 rounded-lg border border-background-300 p-6 text-center">
          <h3 className="text-base font-bold text-foreground-700 mb-2">원하는 답변을 찾지 못하셨나요?</h3>
          <p className="text-sm text-foreground-600 mb-4">고객센터로 문의하시면 빠르게 답변해 드리겠습니다</p>
          <Link
            to="/support"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-foreground-50 text-sm font-bold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-customer-service-2-line" />
            </span>
            고객센터 문의하기
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}